export default __webpack_public_path__ + "static/media/linktree.c630254f.svg";